import React from 'react'
import styles from '../styles/InstantReview.module.scss'
import stylesRaf from '../styles/Raf.module.scss'
import client from '../apollo/apollo-client'
import Head from 'next/head'
import { IMG_URL } from '../apollo/client-url'
import cn from 'classnames'
import { FACEBOOK_URL, INSTAGRAM_URL, LINKEDIN_URL } from '../components/constants'
import { INDEX_PAGE_QUERY } from '../apollo/query/index_page_query'
import * as Sentry from '@sentry/nextjs'
import {useRouter} from "next/router";

export async function getServerSideProps (context) {
  try {
    const { data, error: internalRewardsError } = await client.query({
      query: INDEX_PAGE_QUERY,
      variables: {
        where: {
          pageSlug: context.resolvedUrl
        }
      },
      fetchPolicy: 'no-cache'
    })

    return { props: {
        allMetaTag: data.allMetaTags,
      }};
  }  catch (error) {
    Sentry.captureException(error)
    return { props: {
        allMetaTag: [],
      }};
  }
}

function InstantReview (props) {
  const router = useRouter()

  const metaTag = props.allMetaTag?.[0]

  return (
    <div>
      <Head>
        <title>RAF - yesloyal</title>

        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <link rel="stylesheet" href="static/css/main.css" />

        <script src="static/js/main.js" defer></script>

        <link href="https://fonts.googleapis.com/css?family=Work+Sans:400,500,700&display=swap" rel="stylesheet"/>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />

        {metaTag?.title && <meta name="title" content={metaTag?.title} />}
        {metaTag?.title &&  <meta property="og:title" content={metaTag?.title} />}
        {metaTag?.title && <meta property="twitter:title" content={metaTag?.title} />}

        {metaTag?.description && <meta name="description" content={metaTag?.description} />}
        {metaTag?.description &&  <meta property="og:description" content={metaTag?.description} />}
        {metaTag?.description && <meta property="twitter:description" content={metaTag?.description} />}

        {metaTag?.ogType && <meta property="og:type" content={metaTag?.ogType} />}

        {metaTag?.twitterCard && <meta property="twitter:card" content={metaTag?.twitterCard} />}

        {metaTag?.imagePreview?.publicUrl && <meta property="og:image" content={`${IMG_URL}${metaTag.imagePreview.publicUrl}`} />}
      </Head>

      <main>
        <section className={cn('main_banner')}>
          <header className={cn('header', styles.content_max_width, styles.content_header, styles.content_header_padding)}>
            <a href="/">
              <img src="/logo.png" alt="yesloyal" height='52'/>
            </a>
          </header>

          <div className={cn('content', styles.content_max_width, styles.content_header_padding, stylesRaf.main_section_padding)}>
            <div className={cn('banner_title', styles.banner_title)}>
              <h1 className={cn('main_banner__heads')}>
                Referrals <br/>
                Platform <br/>
              </h1>

              <p className={cn('main_banner__description', stylesRaf.main_banner_description)}>
                Refer a friend marketing is a highly
                effective way to get new customers.
              </p>

              <p className="main_banner__description">
                yesloyal turns members of your
                business into an extension of your marketing.
              </p>

              <div className={styles.action_btn}>
                <a href='https://forms.clickup.com/f/6jran-14182/DB0DV79EKO0A46352G' target='_blank'
                   className={styles.action_btn_trial}
                >
                  START A FREE TRIAl
                </a>
                <a href='https://tidycal.com/yesloyal' target='_blank'
                   className={styles.action_btn_demo}
                >
                  BOOK A DEMO
                </a>
              </div>
            </div>

            <div>
              <img src="/raf_main_section.png" alt="Referrals Platform" className={stylesRaf.main_section_img}/>
            </div>

            <div className={cn('banner_social_button', styles.banner_social_button)}>
              <a className="footer_link-social" href={INSTAGRAM_URL}>
                <img src="/inst.svg" alt=""/>
              </a>
              {/*<a className="footer_link-social" href="#">*/}
              {/*  <img src="/twitter.svg" alt=""/>*/}
              {/*</a>*/}
              <a className="footer_link-social" href={LINKEDIN_URL}>
                <img src="/linkedin.svg" alt=""/>
              </a>
              <a className="footer_link-social" href={FACEBOOK_URL}>
                <img src="/facebook.svg" alt=""/>
              </a>
            </div>
          </div>
        </section>

        <section className={cn(styles.content_max_width, styles.content_header_padding, stylesRaf.benefits_container)}>
          <div>
            <h2 className={stylesRaf.benefits_title}>Business benefits</h2>

            <ul className={stylesRaf.benefits_list}>
              <li>
                Reward members who give you more customers
              </li>
              <li>
                Give points, products, vouchers or discount
              </li>
              <li>
                Simple or complex, we can build your program
              </li>
            </ul>
          </div>
          <div>
            <h2 className={stylesRaf.benefits_title}>Member benefits</h2>

            <ul className={stylesRaf.benefits_list}>
              <li>
                Earn rewards for referrals
              </li>
              <li>
                Pass on exclusive benefits to your family and friends
              </li>
              <li>
                Unique member QR code and referral link
              </li>
            </ul>
          </div>
        </section>

        <section className={stylesRaf.bg}>
          <div className={cn(styles.content_max_width, styles.content_header_padding, stylesRaf.how_it_works_wrap)}>
            <div className={cn(stylesRaf.how_it_works_container)}>
              <span className={stylesRaf.how_it_works_title}>How it works</span>
              <h3
                className={stylesRaf.how_it_works_name}
              >
                Invite your customers
                to become referral
                members
              </h3>
              <p className={stylesRaf.how_it_works_description}>
                Just share a link to your amazing new referral program on
                your website, over social media, in your emails,
                or promote it in-store with QR code posters and stickers!
              </p>
            </div>
            <div className={stylesRaf.how_it_works_icons}>
              <div className={stylesRaf.how_it_works_icons_left}>
                <div className={stylesRaf.how_it_works_icon_item}>
                  <img src="/fb_raf.svg" alt="Facebook"/>
                </div>
                <div className={stylesRaf.how_it_works_icon_item}>
                  <img src="/message.svg" alt="Message"/>
                </div>
              </div>
              <div className={stylesRaf.how_it_works_icons_right}>
                <div className={stylesRaf.how_it_works_icon_item}>
                  <img src="/circle_blue.svg" alt="Icon"/>
                </div>
                <div className={stylesRaf.how_it_works_icon_item}>
                  <img src="/qr_raf.svg" alt="Icon qr code"/>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className={cn(styles.content_max_width, styles.content_header_padding, stylesRaf.how_it_works_wrap)}>
            <div className={stylesRaf.img_container}>
              <img src="speaker.svg" alt="Speaker" className={stylesRaf.image_in_border} />
              <img src="gift_raf.svg" alt="Gift" className={stylesRaf.image_in_border} />
            </div>
            <div className={cn(stylesRaf.how_it_works_container, stylesRaf.how_it_works_container_text_position, stylesRaf.how_it_works_container_friends)}>
              <span className={stylesRaf.how_it_works_title}>How it works</span>
              <h3
                className={stylesRaf.how_it_works_name}
              >
                Your referrers bring
                friends to buy
              </h3>
              <p className={stylesRaf.how_it_works_description}>
                We'll help you choose the perfect gifts to turn your referral
                members and their friends into marketing machines for your business.
                Choose gifts from your own product or service range or from ours.
              </p>
            </div>
          </div>
        </section>

        <section className={stylesRaf.bg}>
          <div className={cn(styles.content_max_width, styles.content_header_padding, stylesRaf.how_it_works_wrap)}>
            <div className={cn(stylesRaf.how_it_works_container)}>
              <span className={stylesRaf.how_it_works_title}>How it works</span>
              <h3
                className={stylesRaf.how_it_works_name}
              >
                You Create Happy
                Customers
              </h3>
              <p className={stylesRaf.how_it_works_description}>
                What could be better than your customers getting rewarded
                for spreading the word about your company?
                Referrers and new customers are both given incentives
                for using your referral program, which lowers the cost of acquiring new customers for you!
              </p>
            </div>
            <div className={stylesRaf.how_it_works_phones}>
              <img src="/this-card-is-yours.png" alt="This card is yours"/>
              <img src="/final-step-to-redeem.png" alt="Final step to redeem"/>
              <img src="/business-chooses-not-to-verify-rewards.png" alt="Not to verify rewards"/>
            </div>
          </div>
        </section>

        <section>
          <div className={cn(styles.content_max_width, styles.content_header_padding, stylesRaf.how_it_works_wrap)}>
            <div className={cn(stylesRaf.img_container, stylesRaf.roi)}>
              <img src="/small_logo.svg" alt="logo"/>
              <div className={stylesRaf.roi_title}>
                Example ROI
              </div>
              <div className={cn(stylesRaf.roi_description, stylesRaf.roi_description_margin)}>
                If you get  <span>8</span>  new referrals,
                Who spend  <span>$20</span>  every month,
              </div>

              <div className={cn(stylesRaf.roi_description)}>
                You’ll be making <br/>
                <span>$1,920</span> <br/>
                Every year
              </div>
            </div>
            <div className={cn(stylesRaf.how_it_works_container, stylesRaf.how_it_works_container_text_position, stylesRaf.how_it_works_container_friends)}>
              <span className={stylesRaf.how_it_works_title}>How it works</span>
              <h3
                className={cn(stylesRaf.how_it_works_name, stylesRaf.how_it_works_name_width)}
              >
                Your Referral
                Program pays for itself
              </h3>
              <p className={stylesRaf.how_it_works_description}>
                You can focus on your business, not on marketing.
                This program runs on autopilot and will pay for itself.
                We will back it with a no questions asked 90 day money back guarantee.
              </p>
            </div>
          </div>
        </section>

        <section className={stylesRaf.bg}>
          <div className={cn(styles.content_max_width, styles.content_header_padding, stylesRaf.demo_wrap)}>
            <h2 className={stylesRaf.demo_title}>
              Want a Demo?
            </h2>
            <p className={stylesRaf.demo_description}>
              We’ve pre-recorded a demo video explaining how the referral platform works.
              You can also speak to one of our team by booking in a ZOOM demo.
            </p>

            <button onClick={() => router.push('https://api.vadoo.tv/landing_page?vid=dQKgE4iFCQLr60vMk11iAiryr4Q2fVuF')} target='_blank'
               className={cn(styles.action_btn_trial, stylesRaf.demo_bth)}
            >
              Watch pre-recorded demo
            </button>

            <a href="https://yesloyal.com/chat" target='_blank' className={stylesRaf.demo_link}>
              Book Live ZOOM Demo
              <span className="icon">
							  <img src="/arrow_blue.svg" alt="Arrow"/>
						  </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  )
}

export default InstantReview